// English dictionary — mirrors the key structure of es.js.
const en = {
  lang: { switch: 'Language' },

  common: {
    delete: 'Delete',
    edit: 'Edit',
    retry: 'Retry',
    dash: '—',
    save: 'Save',
    back: '← Back',
    close: 'Close',
    never: 'Never',
    unassigned: 'Unassigned',
    daysShort: '{count} d',
    ofTotal: '{active} of {total}',
  },
  

  nav: {
    quotes: 'Quotes',
    dashboard: 'Dashboard',
    accounts: 'Accounts',
    calendar: 'Calendar',
  },

  bands: {
    healthy: 'Healthy',
    watch: 'Watch',
    at_risk: 'At risk',
  },

  renewalStatus: {
    confirmed: 'Confirmed',
    in_progress: 'In progress',
    not_started: 'Not started',
    churned: 'Churned',
  },

  billingFrequency: {
    monthly: 'Monthly',
    annual: 'Annual',
  },

  roles: {
    admin: 'Administrator',
    sales: 'Sales',
    cs_agent: 'CS agent',
    none: 'No profile',
  },

  roleSummary: {
    admin: 'Everything, including this console',
    sales: 'Renewal, ARR and sales owner',
    cs_agent: 'Name, internal account, CS owner and sessions',
  },

  sources: {
    mpindustries: 'MPIndustries',
    mpservices: 'MPServices',
  },

  // Flags are built by the backend; translated here by code.
  flags: {
    never_activated: 'Never activated · 0 of {total_users} seats have logged in',
    seat_decay: 'Seat activation down {drop}% vs. prior 30 days',
    admin_only: 'Admin-only usage for 30 days',
    renewal_near: 'Renewal in {days} days',
    unowned: 'No CS owner assigned',
  },

  layout: {
    brandPrefix: 'MP',
    brandName: 'INTERNAL',
    accountMenu: 'Account and administration',
    usersAndPermissions: 'Users and permissions',
    logout: 'Log out',
  },


  dashboard: {
    ownerFilter: {
      label: 'User',
      all: 'Whole team',
    },
    tasks: {
      empty: 'No open tasks.',
      overdue: '{count} overdue',
    },
    loadError: 'Failed to load the dashboard. Please try again.',
    stats: {
      contactToday: 'Contact today',
      atRisk: 'At risk',
      atRiskHint: 'of {total} managed',
      renewals90d: 'Renewals · 90 days',
      renewalsHint: '{count} confirmed',
      renewalRate: 'Renewal rate · 3 months',
      renewalRateOf: '{renewed} of {due}',
      renewalRateNone: 'nothing due',
      unassigned: 'Unassigned',
      awaitingAttendance: 'Awaiting attendance',
      contacted30d: 'Contacted · 30 days',
      contactedHint: '{responded} responded · {sessions} sessions',
    },
    contactToday: {
      title: 'Contact today',
      action: 'Enterprise first, then Business',
      empty: 'Nothing needs a call today — every at-risk account has been contacted in the last 7 days.',
      neverContacted: 'Never contacted',
      lastContact: 'Last contact {days} days ago',
      scoreTrending: 'Score {score} · trending down',
      open: 'Open',
      assign: 'Assign',
    },
    renewals: {
      title: 'Upcoming renewals',
      action: 'This month and next 3',
      empty: 'No renewal dates recorded this month or in the next three. Set them on an account to see them here.',
      daysAgo: '{count} d ago',
      score: 'score {score}',
    },
    renewalMonth: {
      title: 'Renewals for {month}',
      summary: '{renewed} of {due} renewed',
      empty: 'No renewals were scheduled this month.',
      due: 'Due {date}',
      renewedOn: 'Renewed {date}',
      renewed: 'Renewed',
    },
    contacted: {
      title: 'Contacted in the last month',
      action: 'Last 30 days',
      empty: 'Nobody logged a contact in the last 30 days. It is recorded in each account’s contacts.',
      responded: 'Responded',
      noResponse: 'No response',
      waiting: 'Pending',
      session: 'Booked session',
    },
    closeMonth: {
      button: 'Close renewal month',
      title: 'Close renewal month',
      intro: 'Confirmed renewals from months that have ended move to history, their next date rolls forward one period and they go back to «Not started». Renewals that came due without being confirmed are left untouched and listed here for review. This month’s renewals are not closed yet.',
      confirm: 'Close month',
      running: 'Closing…',
      error: 'Could not close the month.',
      summary: 'Due before {date}: {closed} renewals closed, {notRenewed} not renewed.',
      nothing: 'There were no renewals to close.',
      notRenewed: 'Not renewed',
      missingFrequency: 'Confirmed without frequency',
      missingFrequencyHint: 'set the frequency and close again',
      closed: 'Closed',
      next: 'next {date}',
    },
  },

  accounts: {
    saveError: 'Could not save the change.',
    loadError: 'Failed to load accounts. Please try again.',
    search: 'Search organization…',
    allSources: 'All products',
    inactiveBadge: 'TO DEACTIVATE',
    studentBadge: 'STUDENT',
    internalBadge: 'INTERNAL',
    noName: 'no name',
    createdOn: 'Created {date} · {source}',
    views: {
      mine: 'My accounts',
      enterprise: 'Enterprise',
      businessPlus: 'Business Plus',
      renewing: 'Renewing this quarter',
      unowned: 'At risk & unowned',
      inactive: 'Never activated',
      all: 'All',
      internal: 'Internal',
      toDeactivate: 'To deactivate',
      free: 'Free',
      students: 'Students',
    },
    columns: {
      organization: 'Organization',
      subscription: 'Subscription',
      seatsActive: 'Seats active',
      csOwner: 'CS owner',
      salesOwner: 'Sales owner',
      renewal: 'Renewal',
      billingFrequency: 'Frequency',
      lastRenewal: 'Last renewal',
      score: 'Score',
      health: 'Health',
      users: 'Users',
      lastLogin: 'Last login',
      status: 'Status',
    },
  },

  products: {
    title: 'Products and prices',
    intro: 'The catalogue offered when quoting. Editing a price does not change existing quotes: each one stores a copy of what was offered.',
    new: 'New product',
    name: 'Name',
    description: 'Description',
    unit: 'Unit',
    active: 'Active',
    inactive: 'Inactive',
    historyNote: 'Price changes are recorded with author and date.',
    loadError: 'Could not load the catalogue.',
    saveError: 'Could not save the product.',
    forbidden: 'Only an administrator can edit the catalogue.',
  },
  timeline: {
    deleteConfirm: 'Delete this note? This cannot be undone.',
    deleteError: 'Could not delete the note.',
    title: 'Timeline',
    addNote: 'Add note',
    notePlaceholder: 'What happened with this account?',
    empty: 'No activity recorded yet.',
    edited: 'edited',
    loadError: 'Could not load the timeline.',
    saveError: 'Could not save the note.',
  },
  contacts: {
    title: 'Contacts',
    add: 'New contact',
    empty: 'No contacts recorded.',
    name: 'Name',
    jobTitle: 'Job title',
    email: 'Email',
    whatsapp: 'WhatsApp',
    whatsappHint: 'WhatsApp with country code (52 55 1234 5678)',
    whatsappOpen: 'Open the WhatsApp conversation',
    noCountryCode: 'This number has no country code, so WhatsApp cannot be opened. Complete it to get the link.',
    primary: 'Primary',
    makePrimary: 'Make primary contact',
    unsetPrimary: 'Remove as primary contact',
    loadError: 'Failed to load contacts.',
    saveError: 'Could not save the contact.',
    deleteError: 'Could not delete the contact.',
    deleteConfirm: 'Delete this contact? This cannot be undone.',
    lastContact: 'Last contacted',
    today: 'today',
    responded: 'Responded',
    respondedUnknown: '—',
    respondedYes: 'Yes',
    respondedNo: 'No',
    sessionScheduled: 'Booked session',
  },
  implementation: {
    title: 'Implementation plan',
    empty: 'This Enterprise account has no implementation plan yet.',
    add: 'Add plan',
    open: 'Open plan',
    summary: '{done} of {total} tasks · updated {date}',
    progress: 'Progress',
    exportPdf: 'Export PDF',
    exporting: 'Generating PDF…',
    saving: 'Saving…',
    saved: 'Saved',
    saveError: 'Could not save',
    lastUpdate: 'Last edit: {date} · {name}',
    readOnly: 'Your profile can view this plan but not edit it.',
    onlyEnterprise: 'Implementation plans are only for Enterprise accounts.',
    noPlan: 'This account has no implementation plan yet. Create it from the account detail.',
    loadError: 'Could not load the implementation plan.',
    createError: 'Could not create the implementation plan.',
    exportError: 'Could not generate the PDF.',
    alwaysPhase1: 'Always in phase 1',
    steps: {
      account: 'Account and owner',
      start: 'Starting point',
      startHint: 'How do they manage maintenance today?',
      plants: 'Plants and pilot',
      plantsHint: 'We start with one organization (plant or database) and scale from there.',
      scope: 'What to implement first',
      scopeHint: 'What needs to be working to call the implementation a success?',
      users: 'Users and roles',
      notes: 'Integrations and notes',
      tracking: 'Plan tracking',
      trackingHint: 'Tasks adjust to what you checked above. Tap a status to move it: Pending, In progress, Done.',
    },
    fields: {
      client: 'Client',
      kickoff: 'Kickoff date',
      csm: 'Customer Success',
      owner: "Client's implementation owner",
      ownerHint: 'Without this person the project stalls. Confirm it at kickoff.',
      name: 'Name',
      jobTitle: 'Job title',
      email: 'Email',
      admin: 'Account administrator (first to register)',
      adminHint: 'If it is the same person, repeat the name',
      plants: 'Number of plants',
      locations: 'Locations',
      pilot: 'Pilot organization',
      pilotHint: 'Plant or database we start with',
      integrations: 'Integrations',
      integrationsHint: 'System, which one, phase 1 or later, IT contact',
      notes: 'Notes and risks',
      notesHint: 'Anything that could hold the project back',
    },
  },
  tasks: {
    deleteConfirm: 'Delete this task? This cannot be undone.',
    deleteError: 'Could not delete the task.',
    title: 'Tasks',
    add: 'New task',
    placeholder: 'What needs doing?',
    due: 'Due',
    noDate: 'No date',
    assignToMe: 'Assign to me',
    empty: 'No open tasks.',
    loadError: 'Could not load tasks.',
    saveError: 'Could not save the task.',
  },
  quote: {
    issuer: 'Issued by',
    client: 'Client',
    conditions: 'Terms',
    pageOf: 'Page {page} of {total}',
    validUntilHelp: 'One month by default',
    validUntil: 'Valid until',
    pdfError: 'Could not generate the PDF.',
    isRenewal: 'Renewal',
    newClient: 'New client',
    renewalHelp: 'Tick if this quote renews an existing customer',
    type: 'Type',
    accountQuotes: 'Quotes',
    quote: 'Quote',
    quotes: 'Quotes',
    createdDate: 'Created on',
    doneBy: 'Prepared by',
    note: 'Note',
    folio: 'Number',
    company: 'Company',
    contact: 'Contact',
    currency: 'Currency',
    country: 'Country',
    office: 'Issuing office',
    payment: 'Payment terms',
    products: 'Products',
    account: 'Linked account',
    linkAccount: 'Link to an account',
    notLinked: 'Not linked',
    send: 'Send by email',
    downloadPdf: 'Download PDF',
    newQuote: 'New quote',
    sendTo: 'Send to',
    sent: 'Quote sent',
    mailNotConfigured: 'Outgoing email is not configured on the server.',
    loadError: 'Could not load quotes.',
    saveError: 'Could not save the quote.',
    deleteConfirm: 'Delete this quote?',
    total: 'Total',
    status: {
      draft: 'Draft', sent: 'Sent', accepted: 'Accepted',
      rejected: 'Rejected', expired: 'Expired',
    },
    views: { all: 'All', mine: 'Mine', renewals: 'Renewals', newClients: 'New clients' },
  },
  general: {
    pay_terms: 'Payment terms',
    quantity: 'Qty',
    unitPrice: 'Unit price',
    amount: 'Amount',
    product_des: 'Item',
    price_notaxes: 'Prices do not include taxes',
    discount: 'Discount',
    taxes: 'Taxes',
    price: 'Price',
    from: 'From',
    to: 'To',
    subtotal: 'Subtotal',
  },
  accountDetail: {
    timeline: 'Timeline',
    inactiveAccount: 'Account to deactivate',
    inactiveManual: 'Set manually',
    inactiveNone: 'No signs of dormancy',
    inactiveReason: {
      subscription_off: 'Subscription switched off in product',
      no_active_users: 'No active users at all',
      dormant: 'No logins in over 180 days',
    },
    studentAccount: 'Student account',
    studentDetected: 'Detected by domain ({edu} of {total} users are .edu)',
    studentManual: 'Set manually',
    studentHint: 'Excluded from the general view and the dashboard',
    licensedSeats: 'Licensed seats',
    freeUsers: 'Free users',
    freeUsersHint: '{active} of {total} active · no licence consumed',
    contracted: '{contracted} contracted',
    csOwner: 'CS owner',
    salesOwner: 'Sales owner',
    ownerNoAccess: 'no access to the tool',
    assignOwners: 'Ownership',
    loadError: 'Failed to load this account.',
    saveError: 'Could not save your change. Please try again.',
    created: 'Created',
    seatsActive: 'Seats active',
    renewal: 'Renewal',
    renewalStatus: 'Renewal status',
    currentStatus: 'Current status',
    billingFrequency: 'Subscription frequency',
    lastRenewal: 'Last renewal',
    sessions: 'Sessions',
    lastSession: '· last {date}',
    sessionsPending: '· {count} unanswered',
    training: 'Training',
    trainingDone: '{count} delivered',
    trainingTarget: 'contracted',
    orgName: 'Organization name',
    orgNamePlaceholder: 'Enter a name',
    inProduct: 'In product: {name}',
    noProductName: 'The product has no name for this tenant.',
    savedInternally: 'Stored only in the internal database.',
    internalAccount: 'MP internal account',
    internalDetected: 'Detected by domain ({internal} of {total} users)',
    internalManual: 'Set manually',
    whyScore: 'Why this score',
    weight: '{percent}% weight',
    usersCount: 'Users · {count}',
      tips: {
        activation: 'Licensed users who logged in over the last 30 days, out of all licensed users. Free roles (technician, vendor, lead tech, view-only) are excluded because they consume no contract.',
        recency: 'Days since the last login by a licensed user. 100 on the same day, 0 after 45 days idle.',
        trend: 'Licensed users active in the last 30 days versus the 30 before. Holding steady scores 70; growth rises to 100.',
        breadth: 'Distinct roles that logged in over 30 days, out of the roles present in the account. Everyone who logs in counts, licensed or free: usage concentrated in a single profile predicts churn.',
      },
    parts: {
      activation: 'Seat activation',
      recency: 'Login recency',
      trend: 'Trend',
      breadth: 'Breadth',
    },
  },

  calendar: {
    loadError: 'Failed to load your calendar.',
    calendarsError: "Failed to load the team's calendars.",
    notConfigured: 'The Google Calendar connection is not configured on the server. Missing: {missing}',
    footnote: 'Google Calendar events · link a meeting so it counts in the account log',
    ownerLabel: 'Calendar',
    allCalendars: 'Everyone · {count} people',
    noConsoleAccess: 'no console access',
    someFailed: 'Could not read the calendar for: {owners}. The rest of the week is shown.',
    untitled: 'Untitled meeting',
    noAccount: 'No account matched',
    noEvents: 'No events this week.',
    allDay: 'All day',
    when: 'When',
    location: 'Location',
    organizer: 'Organizer',
    attendees: 'Attendees',
    account: 'Account',
    pickAccount: 'Search accounts…',
    link: 'Link',
    linkError: 'Failed to link the meeting.',
    linkNoPermission: 'Your role cannot link meetings.',
    openAccount: 'Open account',
    openInGoogle: 'View in Google Calendar ↗',
    confirmAttendance: 'Confirm attendance',
    attendanceQuestion: 'How did the meeting go?',
    attendanceError: 'Failed to record attendance.',
    session: 'Session',
    sessionHint: 'Type and note are saved when you link the meeting to an account.',
    saveSession: 'Save',
    sessionSaved: 'Saved',
    sessionSaveError: 'Failed to save the session.',
    reason: {
      domain: "Suggested from the guests' domain; confirm to link it.",
      ambiguous: 'Several accounts match the guests; pick one.',
      no_match: 'No guest domain matches an account.',
      internal_only: 'This meeting only has internal attendees.',
    },
    prevWeek: 'Previous week',
    nextWeek: 'Next week',
  },

  attendance: {
    attended: 'Attended',
    partial: 'Partial',
    no_show: 'No show',
    rescheduled: 'Rescheduled',
  },

  sessionsLog: {
    title: 'Sessions',
    empty: 'No sessions logged.',
    loadError: 'Failed to load the session log.',
    saveError: 'Failed to save the session.',
    add: '+ Log one',
    cancel: 'Cancel',
    titlePlaceholder: 'Session title',
    notesPlaceholder: 'What was covered? Comments, agreements, follow-ups…',
    addNotes: '+ Add notes',
    date: 'Date',
    kind: 'Type',
    countsHint: "Counts toward the account's training percentage.",
    noCountHint: 'Kept in the log; does not count toward the training percentage.',
    ofInvited: '{attended} of {invited} invited',
    attendees: '{count} attendees',
    pending: 'No answer',
    showAll: 'Show all {count}',
    showLess: 'Show less',
  },

  kinds: {
    training: 'Initial training',
    support: 'Questions',
    onboarding: 'Onboarding',
    qbr: 'Quarterly review',
    check_in: 'Check-in',
  },

  usersTable: {
    username: 'Username',
    email: 'Email',
    role: 'Role',
    lastLogin: 'Last login',
  },

  usersConsole: {
    requests: 'Access requests',
    unnamedUser: 'Unnamed user',
    noEmailWithId: 'no email in the token · {id}',
    attemptOne: '{count} attempt',
    attemptMany: '{count} attempts',
    lastSeen: 'last {when}',
    admitAs: 'Add as {role}',
    admit: 'Add user',
    dismiss: 'Dismiss',
    admitError: 'The user could not be added.',
    dismissError: 'The request could not be dismissed.',
    registeredNoAccess: 'Registered without access',
    allHaveAccess: 'Every team member has access.',
    title: 'Users and permissions',
    intro: 'Auth0 authenticates; this list authorizes. Anyone not registered here sees nothing of the tool, only a notice — their attempt shows up above as a request.',
    forbidden: 'Only an administrator can open this console.',
    loadError: 'Users could not be loaded.',
    saveError: 'The change could not be saved.',
    search: 'Search by name or email…',
    withAccess: 'With access',
    rolesTitle: 'What each profile can do',
    activity: 'Recent activity',
    noMatches: 'Nobody matches your search.',
    self: '(you)',
    blocked: 'Blocked in Auth0',
    noEmailInToken: 'Signed in with no email in the token',
    lastAccess: 'last access {date}',
    loginCount: '{count} logins',
    notInAuth0: 'not listed in Auth0',
    lastAdminTooltip: 'You cannot remove the last administrator access',
    revoke: 'Revoke',
    grant: 'Grant access',
    someone: 'Someone',
    auth0NotConfigured: 'Only people who have already signed in appear here. To see everyone registered, configure an M2M application with the {read} permission in {id} and {secret}.',
    actions: {
      granted: 'granted access to',
      revoked: 'revoked access from',
      role_changed: 'changed the profile of',
      invited: 'invited',
    },
  },

  noAccess: {
    pendingTitle: 'Your access is pending',
    deniedTitle: 'You do not have access to this tool',
    pendingBody: 'Your account is registered but does not have permissions yet. An administrator has to activate it.',
    deniedBody: 'Your account is not on the Customer Success team. Ask an administrator to register you with this email address.',
  },

  meErrors: {
    session: 'We could not validate your session. Please sign in again.',
    server: 'We could not reach the server.',
  },

  // Errors the backend returns with a `code`; without one, the raw server
  // message is shown as-is.
  apiErrors: {
    NOT_REGISTERED: 'Your account is not registered in this tool.',
    ACCESS_PENDING: 'Your account does not have access yet. Ask an administrator to grant it.',
    FORBIDDEN: 'You do not have permission for this action.',
    ACCOUNT_FORBIDDEN: 'This account is assigned to someone else.',
    FORBIDDEN_FIELDS: 'Your profile cannot edit: {fields}',
    NO_EDITABLE_FIELD: 'No editable field was received.',
    SAVE_FAILED: 'The changes could not be saved.',
    UNKNOWN_ROLE: 'Unknown profile.',
    ACCESS_SAVE_FAILED: 'Access could not be saved.',
    USERS_LOAD_FAILED: 'Users could not be loaded.',
  },
};

export default en;
